import React from 'react';
import './ListPagination.css';

/**
 * Reusable pagination bar for DRF paginated list responses.
 * @param {{ count, next, previous, currentPage, pageSize, onPageChange }} props
 */
const ListPagination = ({
  count = 0,
  next = null,
  previous = null,
  currentPage = 1,
  pageSize = 20,
  onPageChange,
  loading = false,
}) => {
  if (!count || count <= pageSize) {
    return null;
  }

  const totalPages = Math.max(1, Math.ceil(count / pageSize));
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, count);

  const goTo = (page) => {
    if (loading || page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  return (
    <div className="list-pagination">
      <span className="list-pagination-info">
        Showing {start}–{end} of {count}
      </span>
      <div className="list-pagination-controls">
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={!previous || loading}
          onClick={() => goTo(currentPage - 1)}
        >
          Previous
        </button>
        <span className="list-pagination-page">
          Page {currentPage} of {totalPages}
        </span>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={!next || loading}
          onClick={() => goTo(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ListPagination;
